import {
  useCurrentWorkspace,
  useModifyWorkspace,
  useWorkspaceKeysStore,
} from '@easy-expense/data-firestore-client';
import { getTranslation } from '@easy-expense/intl-client';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { Checkbox } from '@mui/material';
import React from 'react';

export const WorkspaceRequireExpenseNotes: React.FC = () => {
  const workspace = useCurrentWorkspace();

  const currentWorkspacePath = useWorkspaceKeysStore((s) => s.currentWorkspacePath());
  const [updateWorkspace] = useModifyWorkspace(currentWorkspacePath, 'update');

  function onChange(requireExpenseNotes: boolean) {
    if (!workspace?.settings) {
      return;
    }
    updateWorkspace({
      settings: {
        ...workspace.settings,
        requireExpenseNotes,
      },
    });
  }

  return (
    <Layout.Row
      align
      style={{
        borderTop: `1px solid ${theme.colors.inputBorder}`,
      }}
      px
      py
    >
      <Layout.Column
        style={{
          maxWidth: 350,
          width: '100%',
        }}
      >
        <Layout.Row align>
          <OpenSans.Primary size={16} weight="bold-700">
            {getTranslation('Require Expense Notes')}
          </OpenSans.Primary>
        </Layout.Row>
        <Layout.Row align>
          <OpenSans.Secondary size={16}>
            {getTranslation('Require a note when saving expenses')}
          </OpenSans.Secondary>
        </Layout.Row>
      </Layout.Column>
      <Spacer.Horizontal size={24} />
      <Layout.Column>
        <Checkbox
          style={{ padding: 0 }}
          checked={!!workspace?.settings.requireExpenseNotes}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.checked);
          }}
        />
      </Layout.Column>
    </Layout.Row>
  );
};
